import { WppActionButton, WppPill, WppPillGroup } from '@wppopen/components-library-react'
import { WppPillCustomEvent } from '@wppopen/components-library/dist/types/components'
import {
  FilterReducerAction,
  FilterReducerState,
  IdValuePair,
  InputFilterComponentData,
  InputFormat,
  SelectFilterComponentData,
} from 'reducers/GenericFiltersReducer/GenericFiltersReducer.d'
import {
  removeAllFilters,
  removeFreetextFilter,
  removeSelectFilter,
  setAreDependantFieldsReady,
} from 'reducers/GenericFiltersReducer/GenericFiltersReducer'
import React, { useCallback, useMemo } from 'react'
import styles from './Filters.module.scss'

interface FilterPillsProps {
  reducerState: FilterReducerState
  reducerDispatch: React.Dispatch<FilterReducerAction>
  filtersId: string
}

function FilterPills({ reducerState, reducerDispatch, filtersId }: FilterPillsProps) {
  const handlePillGroupChange = () => {}

  const handlePillClose = useCallback(
    (event: WppPillCustomEvent<MouseEvent>) => {
      const { dataset, name, value } = event.target
      if (!dataset.parent) return
      const filterObject = reducerState.index[dataset.parent]
      if (!filterObject) return
      if ((dataset.type as InputFormat) === 'select') {
        reducerDispatch(
          removeSelectFilter({
            filterObject: filterObject as SelectFilterComponentData,
            newFilterValue: { id: name, value: value } as IdValuePair,
          }),
        )
        if (filterObject.id === 'clients') reducerDispatch(setAreDependantFieldsReady(false))
      } else if ((dataset.type as InputFormat) === 'text') {
        reducerDispatch(
          removeFreetextFilter({ filterObject: filterObject as InputFilterComponentData, newFilterValue: name! }),
        )
      }
    },
    [reducerDispatch, reducerState.index],
  )

  const activeFilterPills = useMemo(() => {
    const pills: JSX.Element[] = []

    reducerState.orderedFilters.forEach(filterObject => {
      const { parentId, value, labelText, type } = filterObject
      const label = type === 'text' ? (value as string) : (value as IdValuePair).value
      const name = type === 'text' ? (value as string) : (value as IdValuePair).id
      pills.push(
        <WppPill
          label={`${labelText}: ${label}`}
          value={name}
          removable
          onWppClose={handlePillClose}
          key={`${parentId}: ${name}`}
          name={name}
          data-parent={parentId}
          data-type={type}
          data-testid={`filter-pill-${filtersId}-${labelText}: ${value}`}
        />,
      )
    })
    return pills
  }, [reducerState.orderedFilters, handlePillClose, filtersId])

  const handleClearFilters = () => {
    reducerDispatch(removeAllFilters())
  }

  return (
    <>
      {!!activeFilterPills.length && (
        <>
          <WppPillGroup
            type="display"
            onWppChange={handlePillGroupChange}
            className={styles.filter__pillGroup}
            data-testid="pills-container"
          >
            {activeFilterPills}
          </WppPillGroup>
          <WppActionButton
            className={styles.clearFilterAction}
            onClick={handleClearFilters}
            data-testid="clear-all-filters-button"
          >
            Clear all filters
          </WppActionButton>
        </>
      )}
    </>
  )
}

export default FilterPills
